import { render, staticRenderFns } from "./baseTreeSelectCustom.vue?vue&type=template&id=438dbc0c&"
import script from "./baseTreeSelectCustom.vue?vue&type=script&lang=ts&"
export * from "./baseTreeSelectCustom.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports